import { animated, useTrail } from '@react-spring/web';
import EnergyGuzzlersLottie from '@uikit/components/EnergyGuzzlersLottie/EnergyGuzzlersLottie';
import { useState } from 'react';
import EnergyGuzzlersQuizButton from '../EnergyGuzzlersQuizButton/EnergyGuzzlersQuizButton';
import styles from './EnergyGuzzlersQuizContent.module.scss';
import { EnergyGuzzlersQuizContentProps } from './types';

const EnergyGuzzlersQuizContent = ({
  energyGuzzler,
  gotoNextEnergyGuzzler,
  isValidAnswer,
  step = 0,
}: EnergyGuzzlersQuizContentProps) => {
  const [isCorrectlyAnswered, setIsCorrectlyAnswered] = useState(false);

  const answerTrails = useTrail(energyGuzzler.answers.length, {
    from: { opacity: 0, transform: 'translateX(-20%)' },
    to: { opacity: 1, transform: 'translateX(0)' },
    delay: 300,
  });

  const handleAnswerClicked = (answer: string) => {
    if (isValidAnswer(answer)) {
      setIsCorrectlyAnswered(true);
    }
  };

  const handleAnimationEnd = () => {
    setTimeout(() => {
      gotoNextEnergyGuzzler();
    }, 1200);
  };

  const answerButtons = energyGuzzler.answers.map((answer) => (
    <EnergyGuzzlersQuizButton
      key={answer}
      onClick={() => handleAnswerClicked(answer)}
      variant={isValidAnswer(answer) ? 'correct' : 'incorrect'}
      savingsAmount={energyGuzzler.savingsAmount}
      step={step}
    >
      {answer}
    </EnergyGuzzlersQuizButton>
  ));

  return (
    <div className={styles.base}>
      <div className={styles.energyGuzzler}>
        <h3 className={styles.energyGuzzlerName}>{energyGuzzler.name}</h3>
        <p className={styles.energyGuzzlerQuestion}>{energyGuzzler.question}</p>
        <EnergyGuzzlersLottie
          animationId={energyGuzzler.id}
          isPlaying={isCorrectlyAnswered}
          onAnimationEnd={handleAnimationEnd}
          className={styles.lottie}
        />
      </div>
      <div className={styles.answers}>
        {answerTrails.map((props, i) => (
          <animated.div style={props} key={i}>
            {answerButtons[i]}
          </animated.div>
        ))}
      </div>
    </div>
  );
};

export default EnergyGuzzlersQuizContent;
